export const LOGO_CONTAINER_HEIGHT = 274;

export const logo = {
  maxFileSize: 1000, // KB
  formattedMaxFileSize: '1MB',
};
